// src/hooks/useScrollToBottom.js
import { useEffect } from 'react'

export default function useScrollToBottom(ref, deps = []) {
  useEffect(() => {
    ref.current?.scrollIntoView({ behavior: 'smooth' })
  }, [ref, ...deps])
}
